import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
const routes = [
    {
        path: '/', name: 'layout', component: () => import('./view/layout/layout.vue'),
        redirect: { name: 'index' }, //重定向 到首页
        children: [
            {
                path: "/index",
                name: 'index',
                component: () => import('./view/index.vue')
            },
            {
                path:'/introduction',
                name: 'processLayout',
                component: () => import('./view/layout/process-layout.vue'),
                children: [
                    {
                        path: ":type",
                        name: 'good',
                        component: () => import('./view/detail/good-detail.vue'),
                        props: true,
                    },
                    { path: '', name: 'introduction', component: () => import('./view/introduction.vue') },//关键一步
                    {
                        path: ":type",
                        name: 'type',
                        component: () => import('./view/detail/type-detail.vue'),
                        props:true,
                        // redirect: { name: 'type' }, //重定向 到首页
                    },
             
                    {
                        path: ":type",
                        name: 'process',
                        component: () => import('./view/detail/process-detail.vue'),
                        props: true ,
                        // redirect: { name: 'process' }, //重定向 到首页
                    },
                ]
            },
            {
                path: "/about",
                name: 'about',
                component: () => import('./view/about.vue')
            },
            {
                path: "/news",
                name: 'newsLayout',
                component: () => import('./view/layout/news-layout.vue'),
                children: [
                    { path: '', name: 'news', component: () => import('./view/news.vue'),props: true  },
                    { path: ':id', name: 'detail', component: () => import('./view/detail/news-detail.vue'), props: true },
                ]
            },
            {
                path: "/contact",
                name: 'contact',
                component: () => import('./view/contact.vue')
            },

        ]



    }
]

let router = new Router({
    mode: 'history',
    routes,
    linkActiveClass: 'active',
    // 切换滚动回顶部
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }

})
export default router



// WEBPACK FOOTER //
// ./src/router.js